function requireLissenEnv(lissenEnv: string | undefined): string {
  if (!lissenEnv) {
    throw new Error(
      "Missing required runtime env var: LISSEN_ENV. Every service must declare its environment (prod, pr-<n>, local-<user>).",
    );
  }
  return lissenEnv;
}

export function isPreviewEnvironment(
  lissenEnv: string | undefined = process.env.LISSEN_ENV,
): boolean {
  const value = requireLissenEnv(lissenEnv);
  return value.startsWith("pr-") || value.startsWith("local-");
}

export function shouldInitializeSentry({
  dsn = process.env.SENTRY_DSN,
  nodeEnv = process.env.NODE_ENV,
  lissenEnv = process.env.LISSEN_ENV,
}: {
  dsn?: string;
  nodeEnv?: string;
  lissenEnv?: string;
} = {}): boolean {
  return Boolean(dsn) && nodeEnv !== "development" && !isPreviewEnvironment(lissenEnv);
}
